import { Serializable } from '@/models/core/serializable';

export class StatsAllCompetencyGraph implements Serializable<StatsAllCompetencyGraph> {
  competencyID: number;
  competencyName: string;
  avarageResults: AvarageResult[] = [];

  deserialize(input: any): StatsAllCompetencyGraph {
    this.competencyID = input.competencyID;
    this.competencyName = input.competencyName;

    this.avarageResults = [];

    return this;
  }
}

// 受検コース別のあるコンピテンシーの平均スコア
export class AvarageResult implements Serializable<AvarageResult> {
  competencyScore: number; // コンピテンシースコア
  serialNumber: string; // 系列名

  deserialize(input: any): AvarageResult {
    this.competencyScore = input.competencyScore;
    this.serialNumber = input.serialNumber;
    return this;
  }

  get percentScore(): number {
    return Math.floor(this.competencyScore * 100);
  }
}
